<tt-page *ngIf="!!get">
    <tt-page-heading>
        <span ttTranslateWord="p2_m_products"></span><span>{{ !!get.page_heading ? ": " + get.page_heading : "" }}</span>
    </tt-page-heading>
    <tt-card class="col-md-4 col-xs-12 sp-0">
        <tt-input ttRememberId="w_products.filter" ttLabel="filter" [(ttModel)]="get.filter" ttShowClearButton></tt-input>
    </tt-card>
    <tt-list class="col-md-4 col-xs-12 sp-0" [ttData]="products" [ttFilter]="get.filter"></tt-list>
</tt-page>
